import authFetch from "../utils/authFetch";

// IPFS pinning goes through the backend proxy so the Pinata credentials
// never ship in the client bundle. Both endpoints require the user's auth
// token and return { success, IpfsHash, PinSize, Timestamp }.

const getBaseUrl = () =>
  process.env.NEXT_PUBLIC_BASE_URL || process.env.NEXT_PUBLIC_BASE_URL_DEV;

// Pin a File/Blob. pinataMetadata / pinataOptions are optional plain objects
// forwarded to Pinata as-is.
export const pinFileToIPFS = (file, { pinataMetadata, pinataOptions } = {}) => {
  const formData = new FormData();
  formData.append("file", file);
  if (pinataMetadata) {
    formData.append("pinataMetadata", JSON.stringify(pinataMetadata));
  }
  if (pinataOptions) {
    formData.append("pinataOptions", JSON.stringify(pinataOptions));
  }

  // No Content-Type header: the browser sets the multipart boundary.
  return authFetch(`${getBaseUrl()}/api/user/ipfs/pin-file`, {
    method: "POST",
    body: formData,
  });
};

// Pin a JSON document (the content itself, not a wrapper).
export const pinJSONToIPFS = (
  pinataContent,
  pinataMetadata = null,
  pinataOptions = null,
) => {
  return authFetch(`${getBaseUrl()}/api/user/ipfs/pin-json`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      pinataContent,
      ...(pinataMetadata ? { pinataMetadata } : {}),
      ...(pinataOptions ? { pinataOptions } : {}),
    }),
  });
};
